import { Module } from 'vuex';

export const axiosRequestsStore: Module<any, any> = {
  state: {
    pendingRequests: { count: 0 }
  },
  getters: {},
  mutations: {
    increasePendingRequests(state) {
      state.pendingRequests.count++;
    },
    decreasePendingRequests(state) {
      state.pendingRequests.count--;
      if (state.pendingRequests.count < 0) {
        state.pendingRequests.count = 0;
      }
    }
  }
};
